/**
 * Atlas PM · 前端日期工具（P7.9）。
 *
 * ⚠️ 时区教训（P7.8）：绝不能对 Date 直接调用 `toISOString().slice(0, 10)`——
 *    toISOString 输出的是 UTC，东八区凌晨会得到「前一天」。
 *
 * 凡需要 `YYYY-MM-DD`（喂给 input[type=date] / 与后端 DATE 列对齐）一律用
 * 【本地年月日】拼接，与后端 `apps/api/src/common/date-boundary.ts` 的
 * todayUtcDate 保持同一坐标系（本地日历日）。
 */

const pad = (n: number): string => String(n).padStart(2, '0');

/** 本地年月日 → `YYYY-MM-DD`（与 UTC 无关）。 */
export function localYmd(d: Date): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** 本地「今天」的 `YYYY-MM-DD`。 */
export function todayYmd(now: Date = new Date()): string {
  return localYmd(now);
}

/** 本地「今天 + n 天」的 `YYYY-MM-DD`（n 可为负）。 */
export function ymdPlusDays(days: number, now: Date = new Date()): string {
  return localYmd(new Date(now.getTime() + days * 86_400_000));
}
